import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';

import AdminPlaceholder from 'components/consumer/AdminPlaceholder';
import CustomProductList from 'components/consumer/CustomProductList/';
import JavaScriptEmbed from 'components/consumer/HtmlEmbed/JavaScriptEmbed';
import ProgressLoaderDots from 'components/essentials/ProgressLoaderDots/ProgressLoaderDots';
import useProjectResetConfig from 'data-hooks/useProjectResetConfig';

const DEFAULT_CONFIG = {
  customListStyle: 'Slide',
  customListCardStyle: 'medium',
};

const PROJECT_SIMON_PAGE_CONFIG = {
  ...DEFAULT_CONFIG,
  customListSlug: 'pantone-dec-2024',
  pageTitle: 'Joybird x Pantone',
  catalogKey: 'joybird-x-pantone', // syndecaCatalogKey
  guideKey: '82ADE6DA-AF98-1341-AC8B-66A9BBAAC9E7', // syndecaGuideKey
};

const ProjectSimon = () => {
  const { data: projectResetConfig, isLoading } = useProjectResetConfig();

  if (isLoading) {
    return (
      <div className="!text-base inline-flex flex-1 text-center">
        <ProgressLoaderDots inline grey />
      </div>
    );
  }

  const {
    pageTitle,
    catalogKey,
    guideKey,
    customListSlug,
    customListStyle,
    customListCardStyle,
  } = projectResetConfig?.isProjectResetEnabled
    ? projectResetConfig?.projectResetPage ?? {}
    : PROJECT_SIMON_PAGE_CONFIG;

  return (
    <>
      {!!pageTitle && (
        <Helmet>
          <title>{pageTitle}</title>
        </Helmet>
      )}

      {!!catalogKey && !!guideKey && (
        <>
          <div id="syndeca" style={{ height: '685px' }} />
          <JavaScriptEmbed
            js={`<script
                 id="syndeca-embed-script"
                 type="text/javascript"
                 src="//viewer.syndeca.com/scripts/syndeca-embed.js"
                 data-guide-key=${guideKey}
                 data-catalog-key=${catalogKey}
                 ></script>
            `}
          />
        </>
      )}

      {customListSlug && (
        <div className="my-4">
          <CustomProductList
            config={{
              listStyle: customListStyle || DEFAULT_CONFIG.customListStyle,
              filterByStock: false,
              sortByPopularity: false,
              showProductFilters: false,
              elementAttribute: {
                id: `${customListSlug}-page-cl`,
              },
              showFabricOrLeather: false,
              toggleSourceType: {
                manualListId: '',
                selected: {
                  value: 'CustomListInput',
                },
                customListSlug,
              },
              listCardSize: {
                cardSizeSelected:
                  customListCardStyle || DEFAULT_CONFIG.customListCardStyle,
              },
            }}
          />
        </div>
      )}
    </>
  );
};

const ProjectSimonPage = ({ isAdmin }) =>
  isAdmin ? (
    <AdminPlaceholder>ProjectSimonPage component</AdminPlaceholder>
  ) : (
    <ProjectSimon />
  );

ProjectSimonPage.propTypes = {
  isAdmin: PropTypes.bool,
};

export default ProjectSimonPage;
